import { useResendVerification } from '../../model'
import { Fieldset } from '@/common/ui/Form/Fieldset/Fieldset'
import { Input } from '@/common/ui/Form/Input/Input'
import { Button } from '@/common/ui/Form/Button'
import { EMAIL_VALIDATION } from '@/common/ui/Form/Input'

export const VerifyEmailForm = () => {
    const { register, handleSubmit, errors, onSubmit, mutation: resendVerificationMutation } = useResendVerification()

    return (
        <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label='Форма подтверждения email'
            className='w-full flex flex-col gap-[1.875rem]'
        >
            <div>
                <Fieldset label='Введите email для повторного подтверждения' errorText={errors.email?.message} required>
                    <Input
                        type='text'
                        placeholder='Email'
                        className='w-full'
                        size='lg'
                        {...register('email', {
                            required: EMAIL_VALIDATION.required,
                            pattern: EMAIL_VALIDATION.pattern,
                        })}
                    />
                </Fieldset>
            </div>
            {errors.root && <div className='input-error text-center text-sm text-error'>{errors.root.message}</div>}
            <Button
                variant='filled'
                emphasis='accent'
                size='lg'
                className='w-full'
                type='submit'
                loading={resendVerificationMutation.isPending}
                disabled={resendVerificationMutation.isPending}
            >
                Отправить снова
            </Button>
        </form>
    )
}
